import React from 'react';
import { UrgencyBar } from '../components/UrgencyBar';
import { HeroSection } from '../components/HeroSection';
import { StorySection } from '../components/StorySection';
import { TestimonialSection } from '../components/TestimonialSection';
import { OfferSection } from '../components/OfferSection';
import { PricingSection } from '../components/PricingSection';
import { FaqSection } from '../components/FaqSection';
import { GuaranteeSection } from '../components/GuaranteeSection';
import { FinalCtaSection } from '../components/FinalCtaSection';
import { Footer } from '../components/Footer';
export function SalesPage() {
  return <div className="min-h-screen bg-softwhite font-sans text-charcoal selection:bg-sage selection:text-white" data-id="element-231">
      <UrgencyBar data-id="element-232" />

      <main data-id="element-233">
        <HeroSection data-id="element-234" />
        <StorySection data-id="element-235" />
        <TestimonialSection data-id="element-236" />
        <OfferSection data-id="element-237" />
        <PricingSection data-id="element-238" />
        <FaqSection data-id="element-239" />
        <GuaranteeSection data-id="element-240" />
        <FinalCtaSection data-id="element-241" />
      </main>

      <Footer data-id="element-242" />
    </div>;
}